import { Reveal, RevealGroup } from "@/components/Reveal";
import { fadeUp } from "@/lib/motion";
import { motion } from "framer-motion";
import { Wrench, Car, KeyRound, Lock, Droplets, Home, Zap } from "lucide-react";
import { useSiteConfig } from "@/context/SiteConfigContext";

const ICONS = { "flat tire": Car, "dead battery": Zap, "vehicle lockout": KeyRound, "home lockout": Lock, "plumbing leak": Droplets, "need a locksmith": Wrench, "emergency repair": Home };
const iconFor = (label) => ICONS[label.toLowerCase()] || Wrench;

export default function ProblemSection() {
  const { config } = useSiteConfig();
  const t = config.t.problem;
  return (
    <section className="bg-[#FAFAFC] py-28 sm:py-36" data-testid="problem-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">{t.eyebrow}</p>
          <h2 className="mt-4 max-w-3xl text-4xl font-bold tracking-tighter text-neutral-900 sm:text-5xl lg:text-6xl">
            {t.heading}
          </h2>
        </Reveal>

        <RevealGroup className="mt-14 flex flex-wrap gap-3">
          {config.lists.problems.map((label) => {
            const Icon = iconFor(label);
            return (
              <motion.div key={label} variants={fadeUp}
                className="group flex items-center gap-3 rounded-2xl border border-black/5 bg-white px-5 py-4 shadow-sm transition-transform hover:-translate-y-1">
                <div className="grid h-10 w-10 place-items-center rounded-xl bg-brand/5 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <span className="text-[15px] font-semibold text-neutral-800">{label}</span>
              </motion.div>
            );
          })}
        </RevealGroup>

        <Reveal delay={0.1}>
          <p className="mt-14 max-w-2xl text-lg leading-relaxed text-neutral-500">{t.paragraph}</p>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mt-16 text-4xl font-bold tracking-tighter text-neutral-900 sm:text-6xl">
            One place. <span className="text-neutral-300">One request.</span> <span className="text-gradient-blue">Nearby help.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
